/* eslint-disable comma-dangle */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'JudgesContainerBlock';
const CLS = 'judgesContainerBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/judgesContainerBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import slick from 'slick-carousel';

export class JudgesContainerBlock {
	constructor($el) {
		// $el is the widget node return by the loadJudgesContainerBlock function
		this.$el = $el;
	}

	init() {
		this.setJudgesContainerBlock();
	}

	setJudgesContainerBlock() {
		// Add Some logic here
		const $wg = $(this.$el);
		let judges = $wg.find(WG + 'judges');

		const options = {
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: false,
			responsive: [
				{
					breakpoint: 769,
					settings: {
						dots: true,
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};

		judges.slick(options);
	}

	// Add more functions like on above here
}
